import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import styles from "./StartPageStyles.module.scss";
import { Actions } from "../../../../redux/constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import { useSelector } from "react-redux";

function StartPage() {
  const navigate = useNavigate();

  let domain = window.location.hostname;
  domain =
    domain === "localhost" ? process.env.REACT_APP_METADATA_DOMAIN : domain;

  useEffect(() => {
    getStore().dispatch({ type: Actions.API_CHECK_USER_HAS_PLAN });
    getStore().dispatch({ type: Actions.API_ORG_USER_INVITATIONS });
    getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
  }, []);

  const hasPlanData = useSelector((state) => state?.users?.hasPlan);
  const userInvitations = useSelector((state) => state?.users?.userInvitations);
  const orgData = useSelector(
    (state) => state?.organizationsInfo?.dashboardOrg,
  );

  useEffect(() => {
    if (
      hasPlanData === undefined ||
      hasPlanData === null ||
      userInvitations === null ||
      userInvitations === undefined ||
      orgData === undefined ||
      orgData === null
    ) {
      return;
    }

    const hasPendingInvitations = userInvitations?.data?.length > 0;
    const isMemberOfOrg = orgData?.data?.length > 0;

    if (
      domain !== process.env.REACT_APP_FRONTEND_DOMAIN ||
      hasPlanData?.hasPlan ||
      hasPlanData === true ||
      hasPendingInvitations ||
      isMemberOfOrg
    ) {
      navigate("/account/organizations-overview");
    } else {
      navigate("/account/buy-plan");
    }
  }, [hasPlanData, userInvitations, orgData]);

  return <Grid2 className={styles.container} />;
}

export default StartPage;
